import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request whose caller shows its own error message next to the
 * control that failed (e.g. an upload), so the page-level error box stays out
 * of it. Session handling (401/403) still applies.
 */
export const SKIP_ERROR_MESSAGES = new HttpContextToken<boolean>(() => false);
